// import { useTheme } from 'next-themes'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  // const { theme = 'system' } = useTheme()

  return (
    <Sonner
      // theme={theme as ToasterProps['theme']}
      className='toaster group [--width:450px]!'
      toastOptions={{
        classNames: {
          toast:
            'group toast right-0 md:text-base-lg sm:text-base-md text-base-sm rounded-none border-2 group-[.toaster]:bg-white group-[.toaster]:text-blue-d group-[.toaster]:border-blue-d-40 group-[.toaster]:shadow-lg dark:group-[.toaster]:bg-blue-d dark:group-[.toaster]:text-white dark:group-[.toaster]:border-blue-d-80 gap-xs md:p-xs-plus p-xs max-w-fit',
          icon: 'w-auto h-auto',
          content: 'grow',
          title: 'font-bold',
          description:
            'group-[.toast]:text-blue-d dark:group-[.toast]:text-white font-normal',
          actionButton:
            'group-[.toast]:bg-blue-m! uppercase text-tag-lg font-bold tracking-normal rounded-none! group-[.toast]:text-white! dark:group-[.toast]:bg-blue-m dark:group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-blue-m! uppercase text-tag-lg font-bold tracking-normal rounded-none! group-[.toast]:text-white! dark:group-[.toast]:bg-blue-m dark:group-[.toast]:text-white'
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
